<template>
  <div class="NewcomerSignIn">
    <NewcomerSignIn channel="page"/>
  </div>
</template>

<script>
import NewcomerSignIn from '@/components/NewcomerSignIn'
export default {
  name: 'index',
  components: {
    NewcomerSignIn
  }
}
</script>

<style lang="less" scoped>
.NewcomerSignIn{
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/NewcomerSignIn/index.vue